<div class="rd-widget table-widget">
  <table class="widgetLeaseComparablesSummaryClass widget-large cellspacing-0 cellpadding-0" *ngIf="widgetData" aria-hidden="true">
    <thead>
      <dynamic-growth-row [row]="1" [widget]="this">
        <tr class="widget-ruller-flex">
          <th scope="col" colspan="66" class="widget-grid-column" style="text-align: start;">
            <widget-value class="widget-grid-column" [align]="'left'" [color]="'white'" [bold]="true">Improved Sales Summary - Office</widget-value>
          </th>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="2" [widget]="this">
        <tr class="dark-grey-line">
          <th scope="col" colspan="2">
            <widget-value [color]="'white'" [align]="'left'">No.</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Name</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Sale Date</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Year Blt.</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat1Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat4Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat7Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat10Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat13Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat16Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Sale Price</widget-value>
          </th>

          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat19Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryEgiLabel}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Occ. %</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat21Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Cap Rate</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Credit Rating</widget-value>
          </th>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="3" [widget]="this">
        <tr class="dark-grey-line">
          <th scope="col" colspan="2">
            <widget-value [color]="'white'" [align]="'left'">&nbsp;</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Address</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Status</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">&nbsp;</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat2Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat5Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat8Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat11Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat14Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat17Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Effective Price</widget-value>
          </th>

          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat20Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryExpLabel}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">&nbsp;</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat22Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat24Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Source</widget-value>
          </th>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="4" [widget]="this">
        <tr class="dark-grey-line">
          <th scope="col" colspan="2">
            <widget-value [color]="'white'" [align]="'left'">&nbsp;</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">&nbsp;</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Prop. Rights</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">&nbsp;</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat3Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat6Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat9Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat12Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat15Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat18Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">&nbsp;</widget-value>
          </th>

          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">&nbsp;</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryNoiLabel}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">&nbsp;</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usSalesGridCompSummaryCat23Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">&nbsp;</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">&nbsp;</widget-value>
          </th>
        </tr>
      </dynamic-growth-row>
    </thead>
    <tbody class="extraTbody">
      <ng-container *ngFor="let entry of widgetData.rows; let i = index">
        <dynamic-growth-row [row]="5 + i * 7" [widget]="this">
          <tr [ngClass]="{'light-grey-line': (i % 2 !== 0)}">
            <td colspan="2">
              <widget-value [align]="'left'">{{entry.usSalesGridCompSummaryNo}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usSalesGridCompSummaryName}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usSalesGridCompSummarySaleDate | rdLocalizedDate}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usSalesGridCompSummaryYearBuild}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat1 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat4 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat7 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat10 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat13 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat16 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usSalesGridCompSummarySalePrice | rdLocalizedNumber:0}}{{currency}}</widget-value>
            </td>

            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat19 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usSalesGridCompSummaryEgiValue | rdLocalizedNumber: 2}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usSalesGridCompSummaryOccupancy * 100 | rdLocalizedNumber:0}}%</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat21 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usSalesGridCompSummaryCapRate * 100 | rdLocalizedNumber:0}}%</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usSalesGridCompSummaryCreditRating}}</widget-value>
            </td>
          </tr>
        </dynamic-growth-row>
        <dynamic-growth-row [row]="6 + i * 7" [widget]="this">
          <tr [ngClass]="{'light-grey-line': (i % 2 !== 0)}">
            <td colspan="2">
              <widget-value [align]="'left'">&nbsp;</widget-value>
            </td>
            <td colspan="4" rowspan="2">
              <widget-value [align]="'left'">{{entry.usSalesGridCompSummaryAddress}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usSalesGridCompSummaryStatus}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">&nbsp;</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat2 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat5 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat8 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat11 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat14 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat17 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usSalesGridCompSummaryEffectivePrice | rdLocalizedNumber}} {{currency}}</widget-value>
            </td>

            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat20 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usSalesGridCompSummaryExpValue | rdLocalizedNumber: 2}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">&nbsp;</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat22 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat24 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usSalesGridCompSummarySource}}</widget-value>
            </td>
          </tr>
        </dynamic-growth-row>
        <dynamic-growth-row [row]="7 + i * 7" [widget]="this">
          <tr [ngClass]="{'light-grey-line': (i % 2 !== 0)}">
            <td colspan="2">
              <widget-value [align]="'left'">&nbsp;</widget-value>
            </td>
            <!--Address rowspan 2-->
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usSalesGridCompSummaryPropRights}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">&nbsp;</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat3 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat6 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat9 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat12 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat15 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat18 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">&nbsp;</widget-value>
            </td>

            <td colspan="4">
              <widget-value [align]="'left'">&nbsp;</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usSalesGridCompSummaryNoiValue | rdLocalizedNumber: 2}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">&nbsp;</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usSalesGridCompSummaryCat23 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">&nbsp;</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">&nbsp;</widget-value>
            </td>
          </tr>
        </dynamic-growth-row>
        <dynamic-growth-row [row]="8 + i * 7" [widget]="this">
          <tr>&nbsp;</tr>
        </dynamic-growth-row>
        <dynamic-growth-row [row]="9 + i * 7" [widget]="this">
          <tr>
            <td colspan="2">
              <widget-value [align]="'left'"></widget-value>
            </td>
            <td colspan="64">
              <widget-value [align]="'left'">Sale Comments: {{entry.saleComments}}</widget-value>
            </td>
          </tr>
        </dynamic-growth-row>
        <dynamic-growth-row [row]="10 + i * 7" [widget]="this">
          <tr>&nbsp;</tr>
        </dynamic-growth-row>
        <dynamic-growth-row [row]="11 + i * 7" [widget]="this">
          <tr>
            <td colspan="2">
              <widget-value [align]="'left'"></widget-value>
            </td>
            <td colspan="64">
              <widget-value [align]="'left'">General Comments: {{entry.generalComments}}</widget-value>
            </td>
          </tr>
        </dynamic-growth-row>
      </ng-container>
      <dynamic-growth-row [row]="widgetData?.rows?.length * 7 + 5" [widget]="this">
        <tr class="light-grey-line">
          <td colspan="66">
            <widget-value class="contract-summary-widget-header" [align]="'left'" [color]="'white'" [bold]="true">Improved Sales Summary - Office</widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData?.rows?.length * 7 + 6" [widget]="this">
        <tr>
          <td colspan="66">
            *If applicable, prices per SF/unit and capitalization rates and/or income multipliers based on effective sale price.
          </td>
        </tr>
      </dynamic-growth-row>
    </tbody>
  </table>
</div>

